<ifc-base-dialog
  title="Congratulations! You've unlocked a loyalty reward."
  [actions]="actions"
  (actionClicked)="onActionClicked($event)"
>
  <ng-template #content>
    <p class="dialog-description">
      You've successfully completed {{ data.offer.completedPayments }} of {{ data.offer.totalPayments }} scheduled payments on time.
      In recognition of your payment history, Idea Financial is pleased to offer you a loyalty rate reduction on your remaining balance.
    </p>

    <div class="offer-table">
      <div class="offer-row">
        <span class="offer-label">Current rate</span>
        <span class="offer-value">{{ data.offer.currentRate | number:'1.2-2' }}%</span>
      </div>
      <div class="offer-row">
        <span class="offer-label">New rate</span>
        <span class="offer-value">{{ data.offer.newRate | number:'1.2-2' }}% (-2%)</span>
      </div>
      <div class="offer-row">
        <span class="offer-label">Remaining balance</span>
        <span class="offer-value">{{ data.offer.remainingBalance | currency }}</span>
      </div>
      <div class="offer-row">
        <span class="offer-label">Current payment</span>
        <span class="offer-value">{{ data.offer.currentPayment | currency }}</span>
      </div>
      <div class="offer-row">
        <span class="offer-label">New payment</span>
        <span class="offer-value">{{ data.offer.newPayment | currency }}</span>
      </div>
    </div>

    <p class="legal-text">
      By activating this reward, your remaining balance will be re-amortized at the new interest rate. Your updated payment schedule will take effect next billing cycle.
    </p>
  </ng-template>
</ifc-base-dialog>
